<figure [id]="chartId"></figure>
